export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13905.cfd8ace2.jpg";